module.exports = __webpack_public_path__ + "static/img/fwzc_04.2c2af56.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronicDocuments/fwzc_04.png
// module id = knWm
// module chunks = 2